import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Box, IconButton } from '@mui/material';

interface SortableItemProps {
    id: string | number;
    children: React.ReactNode;
    /** Descripción del asa de arrastre para lectores de pantalla. */
    dragLabel?: string;
}

/** Fila del orden de visitas que se arrastra con el asa (también con el teclado). */
const SortableVisitItem: React.FC<SortableItemProps> = ({ id, children, dragLabel }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

    return (
        <Box
            ref={setNodeRef}
            style={{ transform: CSS.Transform.toString(transform), transition }}
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                px: 1.5,
                py: 1,
                mb: 0.75,
                border: 1,
                borderColor: isDragging ? 'primary.main' : 'divider',
                borderRadius: 1,
                bgcolor: 'background.paper',
                position: 'relative',
                zIndex: isDragging ? 1 : 'auto',
                minWidth: 0,
            }}
        >
            <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
            <IconButton
                {...attributes}
                {...listeners}
                aria-label={dragLabel}
                data-tour="visit-order-editor-handle"
                sx={{ cursor: 'grab', color: 'text.secondary', touchAction: 'none' }}
            >
                <DragIndicatorIcon />
            </IconButton>
        </Box>
    );
};

export default SortableVisitItem;
